(function () {
  SignupController.$inject = ["$scope", "$modal", "$location", "PATH", "apiService", "helperService", "EMAIL_PATTERN"];
  app.controller('SignupController', SignupController);

  function SignupController(
      $scope,
      $modal,
      $location,
      PATH,
      apiService,
      helperService,
      EMAIL_PATTERN
  ) {
    var isEmail = helperService.getQueryParameterByName('email');
    $scope.user = { email: checkEmail(isEmail) ? isEmail : '', companyName: '', password: '', password2: '' };
    $scope.show = { 'signup': true };
    $scope.wsErrors = { 'emailInUse': false };
    $scope.state = 'access';

    if (window.location.search.toLowerCase().indexOf('istest2') > -1) {
      $scope.user.isTest = true;
    }

    $scope.validateEmail = validateEmail;

    function validateEmail(userForm) {
      $scope.wsErrors.emailInUse = userForm.submittedEmail === $scope.user.email;
      return !$scope.wsErrors.emailInUse;
    }

    $scope.validateCode = function (code) {
      if (code === 'fidelio') $scope.state = 'signup';
      else $scope.accessError = 'Invalid Access Code';
    };

    $scope.passwordMatch = function () {
      return $scope.user.password === $scope.user.password2 ||
            $scope.user.password === undefined ||
            $scope.user.password2 === undefined;
    };

    $scope.save = function (userForm) {
      userForm.submitted = true;

      if (userForm.$valid && $scope.passwordMatch() && validateEmail(userForm)) {
        userForm.submittedEmail = angular.copy($scope.user.email);

        apiService.postSome('signup/apply', $scope.user, userForm)
                .then(function (response) {
                  $scope.show.signup = false;
                }, function (response) {
                  for (i = 0; i < response.length; i++) {
                    $scope.wsErrors.emailInUse = response[i].errorKey == 'ERROR_EMAIL_ALREADY_IN_USE';
                  }
                });
      }
    };

    $scope.reset = function () {
      $scope.user = { email: '', companyName: '', password: '', password2: '' };
    };

    $scope.termsModal = $modal({
      title: 'Terms of Service',
      show: false,
      prefixClass: 'terms-modal',
      contentTemplate: PATH.apps + 'signup/termsOfService.html'
    });

    $scope.privacyModal = $modal({
      title: 'Privacy Policy',
      show: false,
      prefixClass: 'privacy-modal',
      contentTemplate: PATH.apps + 'signup/privacyPolicy.html'
    });

    var checkModal = function () {
      var absUrl = $location.$$absUrl;
      if (absUrl.indexOf('privacy') > 0) {
        $scope.privacyModal.$promise.then(function () {$scope.privacyModal.show();});
      } else if (absUrl.indexOf('terms') > 0) {
        $scope.termsModal.$promise.then(function () {$scope.termsModal.show();});
      }
    };

    function checkEmail(email) {
      return EMAIL_PATTERN.test(String(email).toLowerCase());
    }

    checkModal();
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/apps/signup/signUpController.js